"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplateColorMap = void 0;
const colors_1 = require("./colors");
const getTemplateColorMap = (inputHexColor) => {
    const { h: baseHue } = (0, colors_1.getHSLFromHex)(inputHexColor);
    const isDullModeValue = (0, colors_1.isDullMode)(inputHexColor);
    const palette = isDullModeValue ? (0, colors_1.getDullPalette)() : (0, colors_1.getLightPalette)(baseHue);
    return {
        [`#1515B7`]: (0, colors_1.hslToHex)(palette.forms.surface.intense),
        [`#BABAF2`]: (0, colors_1.hslToHex)(palette.forms.surface.moderate),
        [`#DFDFFB`]: (0, colors_1.hslToHex)(palette.forms.surface.quiet),
        [`#F0F0FF`]: (0, colors_1.hslToHex)(palette.forms.surface.supershy),
        [`#09093E`]: "#09093E",
        [`#0E0E5D`]: "#0E0E5D",
    };
};
exports.getTemplateColorMap = getTemplateColorMap;
